import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PasswordResetComponent } from 'projects/components/page-components/password-reset/password-reset.component';
import { AuthSetPasswordResponse } from 'projects/login/src/app/services/auth/models/auth-set-password-response';
import { TokenService } from 'projects/login/src/app/services/auth/token.service';
import { TwoFaService } from 'projects/login/src/app/services/auth/two-fa.service';
import { RedirectService } from 'projects/login/src/app/services/redirect/redirect.service';

@Component({
  selector: 'pay-login-act-set-password',
  imports: [PasswordResetComponent],
  templateUrl: './act-set-password.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActSetPasswordComponent implements OnInit {
  private readonly _activatedRoute = inject(ActivatedRoute);
  private readonly _router = inject(Router);
  private readonly _tokenService = inject(TokenService);
  private readonly _twoFaService = inject(TwoFaService);
  private readonly _red = inject(RedirectService);

  token!: string;

  ngOnInit() {
    this._activatedRoute.queryParams.subscribe((params) => {
      this.token = params['token'];

      if (this.token == null) {
        this._router.navigate(['/']);
      }
    });

    this._tokenService.createDefaultSession().subscribe({
      next: (value) => {
        TokenService.sessionId = value.sessionId;
      },
      error: () => {
        this._red.goToInvalidSession();
      },
    });
  }

  routeToNextPage(authSetPasswordResponse: { response: AuthSetPasswordResponse; password: string }) {
    TokenService.password = authSetPasswordResponse.password;
    TokenService.username = authSetPasswordResponse.response.username;
    if (authSetPasswordResponse.response) {
      if (authSetPasswordResponse.response['2faSetupRequired']) {
        this._tokenService.accessToken = authSetPasswordResponse.response.token;
        this._twoFaService.resetQrData();
        this._router.navigate(['/activation/setup-2fa']);
      } else {
        this._router.navigate(['/activation/finished']);
      }
    } else {
      this._router.navigate(['/']);
    }
  }
}
